// A session list shows one row per session (auth folds its claims), and
// signing one out ends all of it: every place it is in use -- its
// organization switches, and the app and any admin tab opened from it,
// which share the app's session (owner, 2026-10-07).
//
// The one sentence for every "sign out this session" confirmation (the
// sessions pages and the audit trail's entry). inOrganization: the caller
// is an organization's admin, whom auth lets end only the session's claims
// in their own organization (DELETE /auth-session/:id and /by-session/:id),
// so it says so.
export const SIGN_OUT_SESSION_TITLE = 'Sign out this session?'
export const signOutSessionBody = (who = '', { inOrganization = false } = {}) =>
  `This signs ${who ? `${who} ` : ''}out everywhere this session is in use${inOrganization ? ' in this organization' : ''}, including any admin tab opened from it.`
// ...and what it leaves alone: someone else's other sessions, or yours
// (signing out a session of your own: signOutSessionBody('you')).
export const OTHER_SESSIONS_STAY = 'Their other sessions stay signed in.'
export const YOUR_OTHER_SESSIONS_STAY = 'Your other sessions stay signed in.'
